module.exports = __webpack_public_path__ + "static/media/stream_twf_video_classes.47f340e8.svg";